export enum GENERAL_INFO_FIELD_NAMES {
	GIVEN = 'given',
	FAMILY = 'family',
	MIDDLE_NAME = 'middle',
	DATE_OF_BIRTH = 'dateOfBirth',
	PATIENT_POINT_OF_CONTACT = 'patientContactPoints',
	GENDER = 'gender',
	GENDER_ID = 'genderId',
	ADDITIONAL_INFORMATION = 'additionalInformation',
	SSN = 'ssn',
	PHONE_NUMBER = 'phone',
	EVENING_PHONE_NUMBER = 'eveningPhone',
	NEEDS_INTERPRETER = 'needsInterpreter',
	EMAIL = 'email',
	CLIENT = 'client',
	ACTIVE = 'active',
	PARTNER = 'partner',
	IMAGE = 'image',
	PROVIDER = 'provider',
	COUNTRY_CODE = 'countryCode',
	EVENING_COUNTRY_CODE = 'eveningCountryCode',
}

export enum ADDRESS_INFO_FIELD_NAMES {
	LINE = 'line',
	LINE1 = 'line1',
	POSTAL_CODE = 'postalCode',
	CITY = 'city',
	STATE = 'state',
	SERVICES = 'services',
	HEIGHT = 'height',
	DEVICE = 'device',
	DEVICE_ID = 'deviceId',
	TIMEZONE = 'timezone',
	WEIGHT = 'weight',
	RACE = 'race',
	EDUCATION = 'education',
	HOUSEHOLD_INCOME = 'householdIncome',
	LANGUAGE = 'language',
	HOUSEHOLD_SIZE = 'houseHoldSize',
	LIVING_WITH_DISABILITY = 'livingWithDisability',
	//  new
	HOUSEHOLD_INCOME_ID = 'householdIncomeId',
	EDUCATION_ID = 'educationId',
	RACE_ID = 'raceId',
	ETHNICITY = 'ethnicity',
	ETHNICITY_ID = 'ethnicityId',
}

export enum MEMBER_COMPONENT_TYPE {
	GENERAL_INFO = 'generalInfo',
	INSURANCE_INFO = 'insuranceInfo',
	ADDRESS_INFO = 'addressInfo',
}

export enum INSURANCE_INFO_FIELD_NAMES {
	INSURANCE_NAME = 'insuranceName',
	HOLDER_NAME = 'holderName',
	SELF = 'relationShipToInsured',
	SELF_ID = 'relationShipToInsuredId',

	MEDICAID = 'medicaid',
	MEDICARE = 'medicare',
	UNDER_INSURED = 'underInsured',
	REF_TO_INSURANCE = 'refToInsurance',
	DATE_REF_TO_INSURANCE = 'dateRefToInsurance',
	INSURANCE_INFO = 'insuranceInfo',
	EDIT_INSURANCE_ID = 'insuranceId',
	INSURANCE_PLAN = 'plan',
	INSURANCE_PLAN_ID = 'planId',

	INSURANCE_ID = 'groupId',
	IMAGE = 'image',
	PROVIDER = 'provider',
	COUNTRY_CODE = 'countryCode',
	RACE = 'race',
	RACE_ID = 'raceId',

	EDUCATION = 'education',
	EDUCATION_ID = 'educationId',
	HOUSEHOLD_INCOME = 'householdIncome',
	HOUSEHOLD_INCOME_ID = 'householdIncomeId',
	PARTNER = 'partner',
	TIMEZONE = 'timezone',
	ETHNICITY = 'ethnicity',
}
export const GENDER_OPTIONS = [
	{ value: 'female', label: 'Female' },
	{ value: 'male', label: 'Male' },
	{ value: 'unknown', label: 'Unknown' },
]

export const RACE_OPTIONS = [
	{ value: 'White', label: 'White' },
	{ value: 'Black or African American', label: 'Black or African American' },
	{ value: 'Asian', label: 'Asian' },
	{
		value: 'Native Hawaiian or Other Pacific Islander',
		label: 'Native Hawaiian or Other Pacific Islander',
	},
	{ value: 'American Indian or Alaska Native', label: 'American Indian or Alaska Native' },
	{ value: 'Unknown', label: 'Unknown' },
]

export const EDUCATION_OPTIONS = [
	{ value: '<9th grade', label: '<9th grade' },
	{ value: 'Some high school', label: 'Some high school' },
	{ value: 'High school graduate or equivalent', label: 'High school graduate or equivalent' },
	{ value: 'Some college or higher', label: 'Some college or higher' },
	{ value: 'Don’t know', label: 'Don’t know' },
	{ value: 'Don’t want to answer', label: 'Don’t want to answer' },
]

export const HOUSEHOLD_INCOME_OPTIONS = [
	{ value: 'Under $15k', label: 'Under $15k' },
	{ value: '$15k to $35k', label: '$15k to $35k' },
	{ value: '$35k to $55k', label: '$35k to $55k' },
	{ value: '$55k to $75k', label: '$55k to $75k' },
	{ value: '$75k to $95k', label: '$75k to $95k' },
	{ value: '$95k to $115k', label: '$95k to $115k' },
	{ value: '$115k to $135k', label: '$115k to $135k' },
	{ value: '$135k to $150k', label: '$135k to $150k' },
	{ value: 'Over $150k', label: 'Over $150k' },
]

export const ETHNICITY_OPTIONS = [
	{ label: 'Hispanic or Latino', value: 'Hispanic or Latino' },
	{ label: 'Non Hispanic or Latino', value: 'Non Hispanic or Latino' },
]

export const SERVICE_TYPE_LIST = [
	{ value: 'CCM', label: 'CCM' },
	{ value: 'publicHealth', label: 'PUBLIC HEALTH' },
	{ value: 'AWV', label: 'AWV' },
	{ value: 'MTM', label: 'MTM' },
	{ value: 'Wellness', label: 'Wellness' },
]

export const PLAN_LIST = [
	{ value: 'HMO', label: 'HMO' },
	{ value: 'PPO', label: 'PPO' },
	{ value: 'EPO', label: 'EPO' },
	{ value: 'POS', label: 'POS' },
	{ value: 'HDHP', label: 'HDHP' },
]

export const SELF_LIST = [{ value: 'Self', label: 'Self' }]

export enum FORM_NAME {
	GENERAL_INFO = 'generalInfo',
	ADDRESS_INFO = 'addressInfo',
	INSURANCE_INFO = 'insuranceInfo',
}
// Get Phone Number Dropdown

export const IS_PHONE_OPTIONS = [{ value: '+1', label: '+1' }]
export enum COUNTRY_CODE_TYPE {
	countryCode = '+1',
}

export enum EVENING_COUNTRY_CODE_TYPE {
	eveningCountryCode = '+1',
}

export const DEVICES_OPTIONS = [
	{ value: 'ios', label: 'Ios' },
	{ value: 'Android', label: 'Android' },
]

export const ACTIVE_OPTIONS = [
	{ value: 'isActive', label: 'Is Active' },
	{ value: 'isInactive', label: 'Is Inactive' },
]

export const LIVING_WITH_DISABILITY_OPTIONS = [
	{ value: 'yes', label: 'Yes' },
	{ value: 'no', label: 'No' },
]

export const INTERPRETER_OPTIONS = [
	{ value: 'isActive', label: 'Yes' },
	{ value: 'isInactive', label: 'No' },
]

export const Medicare_OPTIONS = [
	{ value: 'isActive', label: 'Yes' },
	{ value: 'isInactive', label: 'No' },
]

import TableSortHeader from 'components/TableSortHeader'

export const membersColumns = [
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Name</TableSortHeader>,
		accessor: 'col1', // accessor is the "key" in the data
		name: 'name',
		sortable: true,
	},

	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Date of Birth</TableSortHeader>,
		accessor: 'col3',
		name: 'dateOfBirth',
		sortable: true,
	},
	{
		Header: 'Email',
		name: 'contacts',
		accessor: 'col4',
	},

	{
		Header: 'Status',
		accessor: 'col5',
		name: 'status',
		sortable: false,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>City</TableSortHeader>,
		accessor: 'col6',
		name: 'city',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>State</TableSortHeader>,
		accessor: 'col7',
		name: 'state',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Client</TableSortHeader>,
		accessor: 'col8',
		name: 'client',
		sortable: true,
	},
	{
		Header: 'Actions',
		accessor: 'col9',
		name: 'actions',
	},
]

export const membersAlertColumns = [
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Name</TableSortHeader>,
		accessor: 'col1', // accessor is the "key" in the data
		name: 'name',
		sortable: true,
	},
	{
		Header: 'Alert',
		name: 'alert',
		accessor: 'col2',
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Date of Birth</TableSortHeader>,
		accessor: 'col3',
		name: 'dateOfBirth',
		sortable: true,
	},
	{
		Header: 'Email',
		name: 'contacts',
		accessor: 'col4',
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Provider</TableSortHeader>,
		name: 'provider',
		accessor: 'col5',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Partner</TableSortHeader>,
		name: 'partner',
		accessor: 'col6',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Status</TableSortHeader>,
		accessor: 'col7',
		name: 'status',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>City</TableSortHeader>,
		accessor: 'col8',
		name: 'city',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>State</TableSortHeader>,
		accessor: 'col9',
		name: 'state',
		sortable: true,
	},
	{
		Header: ({ ...rest }) => <TableSortHeader {...rest}>Client</TableSortHeader>,
		accessor: 'col10',
		name: 'client',
		sortable: true,
	},
	{
		Header: 'Actions',
		accessor: 'col11',
		name: 'actions',
	},
]
export enum MemeberLabels {
	MEMBER_ID = 'Member Id',
	DATE_OF_BIRTH = 'Date of Birth',
	CLIENT_NAME = 'Client Name',
	PHONE_NUMBER = 'Phone Number',
	STATUS = 'Member Status',
	ACTIVE = 'Active',
	INACTIVE = 'Inactive',
	TIMEZONE = 'timezone',
}

export enum PROGRAM_ENROLLMENT_FILTER_FIELDS {
	SEARCH = 'Search',
	CLIENT = 'Client',
	PARTNER = 'Partner',
	STATUS = 'Status',
	STATE = 'State',
	CITY = 'City',
	PROGRAM = 'program',
	ENROLLMENT_PERIOD = 'programEnrollmentPeriod',
	ENROLLMENT_STATUS = 'enrollmentStatus',
}
export const countryCodeKeyValue = {
	label: '+1',
	value: '+1',
}
